import { render } from "./MyRequests.vue?vue&type=template&id=2836272a"
import script from "./MyRequests.vue?vue&type=script&lang=js"
export * from "./MyRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__